import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {EditorMmcModelService} from "@irb/irb-editors/editor-mmc-model/editor-mmc-model.service";
import {IrbAppEvents} from "@irb/app.events";
import {AppService} from "@irb/app.service";
import {IAlertDialogData, IUserDetails} from "@irb/app.model";
import {UtilityService} from "@irb-common/services/utility.service";

@Component({ standalone: false,
    selector: 'irb-mmc-overview-marketing-documents',
    templateUrl: './mmc-overview-marketing-documents.component.html',
    styleUrls: ['./mmc-overview-marketing-documents.component.scss']
})

export class MmcOverviewMarketingDocumentsComponent implements OnInit {
    private _modelData: any;
    samlResponse: any;
    samlActionURL: any;
    marketingDocuments: any[]
    isLoading = true;
    public _selectedDocument: any = null;
    urlRegex = /^((http|https|ftp|ftps)(:\/\/))([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/i;
    isModelProvider: boolean = false;

    constructor(private editorMmcService: EditorMmcModelService, private as: AppService, private utilService: UtilityService) {
    }

    ngOnInit(): void {
        const userDetails = this.as.getItem("IRB_APP_CONFIG");
        if (userDetails) {
            this.isModelProvider = userDetails.isModelProvider;
        }
    }

    @Input()
    set modelData(value: any) {
        this.isLoading = true;
        this._modelData = value;
        this.loadMarketingDocuments();
    }

    private loadMarketingDocuments() {
        this.isLoading = true;
        if (this._modelData.modelMarketId) {
            this.editorMmcService
                .getMarketingDocuments(this._modelData.modelMarketId, true)
                .subscribe((response: any) => {
                    if (response !== undefined) {
                        this.marketingDocuments = response;
                        this.utilService.sortByKey(this.marketingDocuments, 'displayOrder', 'asc');
                        if (this._modelData.usedFor !== 'custom') {
                            this.marketingDocuments.unshift({
                                isLink: true,
                                title: "Informa Product Report",
                                sourceId: this._modelData.sourceId
                            });
                        }
                    } else {
                        let errorMessage = "An error occurred processing your request.";
                        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                            severity: 'error',
                            summary: '',
                            detail: errorMessage
                        });
                    }
                    this.isLoading = false;
                }, () => {
                    let errorMessage = "An error occurred sending your request.";
                    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                        severity: 'error',
                        summary: '',
                        detail: errorMessage
                    });
                    this.isLoading = false;
                });
        } else {
            if (this._modelData.usedFor !== 'custom')
                this.marketingDocuments = [{
                    isLink: true,
                    title: "Informa Product Report",
                    sourceId: this._modelData.sourceId
                }];
            this.isLoading = false;
        }
    }

    openMarketingDocument(data: any) {
        this._selectedDocument = data;
        this.showMMCDisclosureAgreementConfirm();
    }

    openMarketingDocumentContinue(data: any) {
        if (data.sourceId) {
            this.openDocumentUsingSSO(data);
        } else if (data.isLink) {
            this.openLink(data);
        } else {
            this.openDocument(data);
        }
    }

    getImageIcon(document: any) {
        if (document.isLink) {
            return "../../../../assets/images/icon_LINK.gif";
        } else {
            return "../../../../assets/images/icon_PDF.gif";
        }
    }

    showMMCDisclosureAgreementConfirm() {
        let msg = "<div class='block' style='font-weight:normal'><strong>You are now leaving Schwab.com and linking to third-party content.</strong> ";
        msg += "This third-party content is intended for informational purposes only and is provided by the model manager. Charles Schwab & Co., Inc. (Schwab) is not responsible for the content and does not provide, edit, or endorse any of the content. The information is not intended to provide tax, legal or investment advice or recommendations. Schwab does not guarantee that the content or material is accurate, complete or timely, nor does Schwab make any warranties to you regarding any results from use of the information. The information is not a substitute for appropriate model or other investment due diligence. As a registered investment adviser, you are solely responsible for all upfront and ongoing manager and model due diligence, monitoring of any model or model information available via the Model Market Center™ (MMC), and for evaluating the information available via third-party content. You may not use any of the information via third-party content or the MMC, except as provided for in the MMC Advisory Agreement.</div>"
        this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
            dTitle: 'Important Disclosure',
            dProceedBtnLabel: 'Continue',
            dCancelBtnLabel: 'Cancel',
            altMsgHTML: msg,
            dWidth: 720,
            onProceed: () => {
                this.openDocumentOnConfirm();
            }
        } as IAlertDialogData);
    }

    openDocumentUsingSSO(data: any) {
        this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
        this.editorMmcService.getInformaSAMLResponse(data.sourceId).subscribe((response: any) => {
            if (response !== undefined) {
                this.samlActionURL = response.SAML_ACTION_URL;
                this.samlResponse = response.SAML_RESPONSE;
                this.submitInformaPost();
                this._selectedDocument = null;
            } else {
                let errorMessage = "An error occurred processing your request.";
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: 'error',
                    summary: '',
                    detail: errorMessage
                });
                this._selectedDocument = null
                this.samlActionURL = null;
                this.samlResponse = null;
            }
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        }
        , () => {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            let errorMessage = "An error occurred processing your request.";
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'error',
                summary: '',
                detail: errorMessage
            });
            this._selectedDocument = null;
            this.samlActionURL = null;
            this.samlResponse = null;
        }, () => {

        });
    }

    openLink(data: any) {
        if(this.urlRegex.test(data.name)) {
            window.open(data.name, "_blank");
        } else {
            console.warn("Invalid url can not be opened: " + data.name)
        }

        this._selectedDocument = null;
    }

    openDocument(data: any) {
        this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
        let fileName = data.name;
        this.editorMmcService.getMarketingDocumentPDF(data.id).subscribe((data: any) => {
            // let file = new Blob([data], {type: 'application/pdf'});
            // let fileURL = URL.createObjectURL(file);
            // window.open(fileURL, "_blank");
            const blob = new Blob([data], { type: 'application/pdf' });
            let clickEvent = null;
            const url = window.URL.createObjectURL(blob);
            const linkElement = document.createElement('a');
            linkElement.setAttribute('href', url);
            linkElement.setAttribute('download', fileName);
            if (document.createEvent) {
                clickEvent = document.createEvent('MouseEvent');
                clickEvent.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            } else {
                clickEvent = new MouseEvent('click', {
                    'view': window,
                    'bubbles': true,
                    'cancelable': false
                });
            }
            linkElement.dispatchEvent(clickEvent);
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
                // document.body.removeChild(linkElement);
            }, 0)
        }, () => {
        }, () => {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            this._selectedDocument = null;
        });
    }

    openDocumentOnConfirm() {
        if (this._selectedDocument.sourceId && this.samlActionURL) {
            this.submitInformaPost();
        } else {
            this.openMarketingDocumentContinue(this._selectedDocument);
        }

    }

    submitInformaPost() {
        setTimeout(() => {
            let informaForm: any = document.getElementById('informaForm');
            if (informaForm) {
                informaForm.submit();
                this.samlResponse = null;
                this.samlActionURL = null;
            }
        }, 500);

    }

}
